export default class RoleManagementColumnModel {
	static RoleManagementColumn = [
	  {
		  title: 'Role name',
		  align: 'left',
		  field: 'roleName'
	  }
	]
}
